import { motion, AnimatePresence } from "framer-motion";
import { CheckIcon } from "@heroicons/react/outline";

import { StepT } from "../../Step/types";

import { cn } from "@/lib/utils";

interface GroupStepProps {
  step: StepT;
  groupIndex: number;
  stepIndex: number;
  isCompleted: boolean;
  isCurrent: boolean;
}

export const GroupStep = ({
  step,
  groupIndex,
  stepIndex,
  isCompleted,
  isCurrent,
}: GroupStepProps) => (
  <motion.div
    key={step.id}
    className="flex flex-col"
    initial={{ opacity: 0, x: -10 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.3,
      delay: groupIndex * 0.1 + stepIndex * 0.05,
    }}
  >
    <motion.div
      className={cn(
        "flex w-full items-center gap-2.5 rounded-md px-2.5 py-0.5 text-left transition-all duration-200 ease-out",
        isCurrent && "bg-gray-50",
      )}
      transition={{ duration: 0.2 }}
    >
      <div className="flex items-center gap-2">
        <AnimatePresence>
          {isCompleted ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
            >
              <CheckIcon className="h-4 w-4 text-green-500" />
            </motion.div>
          ) : (
            <div className="h-4 w-4" />
          )}
        </AnimatePresence>
        <motion.span
          className={cn(
            "text-sm text-gray-700",
            isCompleted && "text-gray-500",
            isCurrent && "font-medium",
          )}
          transition={{ duration: 0.15 }}
        >
          {step.title}
        </motion.span>
      </div>
    </motion.div>
  </motion.div>
);
